import { createContext, useContext } from "react";

export const LeadBackNavigation = createContext<((action: (() => void) | null) => void) | null>(null);

export function useLeadBackNavigation() {
  return useContext(LeadBackNavigation);
}
